var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 52",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "015---AR-Object-Desktop",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#3b97d3",
    height: 52,
    rx: 6,
    width: 58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 10v26l-12-6h-13v-22h23c1.1032019.0032948 1.9967052.89679813 2 2z",
    fill: "#955ba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29 8v22h-13l-12 6v-26c.0032948-1.10320187.89679813-1.9967052 2-2z",
    fill: "#894b9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 36v10c-.0032948 1.1032019-.8967981 1.9967052-2 2h-46c-1.10320187-.0032948-1.9967052-.8967981-2-2v-10l12-6h26z",
    fill: "#5d4c72"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5,
    cy: 4,
    fill: "#65ddb9",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 4,
    fill: "#f0c419",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13,
    cy: 4,
    fill: "#e64c3c",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52 3h-14c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1h14c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 21-13 7-13-7 13-7z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29 28v14l-13-7v-14z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 21v14l-13 7v-14z",
    fill: "#f29c1f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmLogo);
export default __webpack_public_path__ + "static/media/vmLogo.e93a3a8a042a78a55b8903afb3f1c08e.svg";
export { ForwardRef as ReactComponent };